var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.999 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17515",
    d: "M16 30h-.126a3.161 3.161 0 01-2.215-1.024L2.708 17.031A10.441 10.441 0 012.708 3a9.275 9.275 0 016.81-3A9.124 9.124 0 0116 2.673a9.21 9.21 0 0113.283.337 10.443 10.443 0 010 14.044L18.339 28.972c-.06.064-.117.123-.179.18A3.158 3.158 0 0116 30M9.519 3a6.183 6.183 0 00-4.6 2.03 7.42 7.42 0 000 9.974l10.947 11.939a.177.177 0 00.125.057.242.242 0 00.131-.049l10.956-11.928a7.42 7.42 0 000-9.983 6.213 6.213 0 00-9.191 0l-.782.847a1.5 1.5 0 01-2.2 0l-.791-.856A6.175 6.175 0 009.519 3",
    fill: "currentColor"
  })));
}
export default SvgHeart;